import script from "./task-quick-audit-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./task-quick-audit-list.vue?vue&type=script&lang=tsx&setup=true"

import "./task-quick-audit-list.vue?vue&type=style&index=0&id=3edd141c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3edd141c"]])

export default __exports__